import { SVGProps, Ref, forwardRef } from 'react';

export const ScooterOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 0v1.4h2.11l2.178 9.416c-.93.299-1.395 1.012-1.555 1.817H5.267c-.211-1.063-.954-1.966-2.6-1.966C.667 10.667 0 12 0 13.333 0 14.667.667 16 2.667 16c1.646 0 2.389-.903 2.6-1.967h5.466c.211 1.064.954 1.967 2.6 1.967 2 0 2.667-1.333 2.667-2.667 0-1.25-.586-2.499-2.306-2.65L11.224 0zM1.4 13.333c0-.458.117-.767.259-.937.104-.125.344-.33 1.008-.33.663 0 .903.205 1.007.33.142.17.26.479.26.937s-.118.768-.26.938c-.104.124-.344.329-1.007.329-.664 0-.904-.205-1.008-.33-.142-.17-.259-.478-.259-.937m10.667 0c0-.458.117-.767.258-.937.105-.125.345-.33 1.008-.33.664 0 .904.205 1.008.33.142.17.259.479.259.937s-.117.768-.259.938c-.104.124-.344.329-1.008.329-.663 0-.903-.205-1.008-.33-.141-.17-.258-.478-.258-.937"
                    fill="currentColor"
                />
                <path d="M1.333 3.967H6v1.4H1.333z" fill="currentColor" />
                <path d="M3.333 7.3H8v1.4H3.333z" fill="currentColor" />
            </g>
        </g>
    </svg>
));
ScooterOutlinedSize16Glyph.displayName = 'ScooterOutlinedSize16Glyph';
